import {customElement, property, state} from "lit/decorators.js";
import {UnLitElement} from "../../common/elements";
import {Dictionary} from "../../page/elements/dictionary";
import {html, type PropertyValues, type TemplateResult} from "lit";
import {eopCustomEvent} from "../../common/utils/events";

export type CareerGptMessageRatingEvent = CustomEvent<CareerGptMessageRatingEventData>;

export const CAREER_GPT_MESSAGE_RATING_EVENT = "career-gpt-message-rating";

export type CareerGptMessageRatingEventData = {
    ratingPositive: boolean;
    assistantMessageId: string;
};

@customElement("eop-career-gpt-message-rating")
export class CareerGptMessageRating extends UnLitElement {

    @state()
    private ratingPositive: boolean | undefined;

    @property({attribute: "assistant-message-id", type: String})
    public assistantMessageId: string | undefined;

    private dictionary: Dictionary;

    public connectedCallback(): void {
        super.connectedCallback();

        this.dictionary = Dictionary.of(this);
    }

    public render(): TemplateResult {
        const ratingLocked = this.ratingPositive !== undefined;
        const ratingWasPositive = this.ratingPositive === true;
        const ratingWasNegative = this.ratingPositive === false;
        return html`
            <div class="chat-message-rating" ?rateable=${this.assistantMessageId !== undefined}>
                <button type="button"
                        class="thumbs-up"
                        ?selected=${ratingWasPositive}
                        ?disabled=${ratingLocked}
                        aria-label=${this.dictionary.translate("MSG_THUMBS_UP_LABEL")}
                        aria-pressed=${ratingWasPositive}
                        @click=${() => this.rateResponse(true)}
                ><eop-svg-sprite-icon icon-id="thumbs_up"></eop-svg-sprite-icon></button>
                <button type="button"
                        class="thumbs-down"
                        ?selected=${ratingWasNegative}
                        ?disabled=${ratingLocked}
                        aria-label=${this.dictionary.translate("MSG_THUMBS_DOWN_LABEL")}
                        aria-pressed=${ratingWasNegative}
                        @click=${() => this.rateResponse(false)}
                ><eop-svg-sprite-icon icon-id="thumbs_down"></eop-svg-sprite-icon></button>
            </div>
        `;
    }

    protected updated(changedProperties: PropertyValues): void {
        if (changedProperties.has("assistantMessageId")) {
            this.ratingPositive = undefined;
        }
    }

    private rateResponse(ratingPositive: boolean): void {
        if (this.ratingPositive !== undefined || !this.assistantMessageId) {
            return;
        }

        this.ratingPositive = ratingPositive;
        this.dispatchEvent(eopCustomEvent(CAREER_GPT_MESSAGE_RATING_EVENT, {ratingPositive, assistantMessageId: this.assistantMessageId}));
    }
}